import { Component, OnInit } from "@angular/core";
import { ChartOptions, ChartType, ChartDataset, ChartConfiguration } from "chart.js";
import { Company } from "src/app/ui/models/domains/pbm/companies/company";
import { ProductSubtypeIndicatorData } from "src/app/ui/models/domains/pbm/indicators/product-subtype-data";
import { IndicatorService } from "src/app/ui/services/pbm/indicator.service";
import { ProductSubtypeIndicatorDataStrategy } from "src/app/ui/pages/home/indicator-data-strategies";
import { IndicatorMediator } from "src/app/ui/services/pbm/indicator-mediator";
import * as pluginAnnotations from "chartjs-plugin-annotation";
import * as pluginDataLabels from "chartjs-plugin-datalabels";

@Component({
  selector: "product-subtype-indicator",
  templateUrl: "./product-subtype-indicator.component.html",
  styleUrls: ["./product-subtype-indicator.component.scss"],
})
export class ProductSubtypeIndicatorComponent implements OnInit {
  public productSubtypeData: ProductSubtypeIndicatorData;

  public barChartOptions: ChartOptions & { annotation: any } = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        ticks: {
          color: "#090f34",
        },
      },
      y: {
        position: "left",
        min: 0,
        ticks: {
          stepSize: 0,
          color: "#090f34",
          font: {
            size: 13,
          },
        },
      },
    },
    annotation: {
      annotations: [
        {
          type: "bar",
          label: {
            enabled: true,
            fontColor: "#090f34",
            content: "LineAnno",
          },
        },
      ],
    },
    plugins: {
      datalabels: {
        anchor: "end",
        align: "center",
        color: "#090f34",
      },
      legend: {
        display: true,
        position: "bottom",
        labels: {
          color: "#090f34",
          font: {
            size: 12
          }
        },
      },
    },
  };
  public barChartLabels: string[] = [""];
  public barChartType: ChartType = "bar";
  public barChartLegend = true;
  public barChartPlugins = [pluginDataLabels, pluginAnnotations];
  public barChartData: ChartDataset[] = [];


  lineChartData: ChartConfiguration<'bar'>['data'];
  public lineChartLabels: string[] = [""];
  public lineChartOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: true,
    scales: {
      x: {
        ticks: {
          color: "#090f34",
        },
      },
      y: {
        position: "left",
        min: 0,
        ticks: {
          stepSize: 0,
          color: "#090f34",
          font: {
            size: 13,
          },
        },
      },
    },
    plugins: {
      legend: {
        display: true,
        position: "bottom",
        labels: {
          color: "#090f34",
          font: {
            size: 12
          }
        },
      },
      datalabels: {
        anchor: "end",
        align: "center",
        color: "#090f34",
      },
    },
  };

  public isLoading: boolean = true;

  constructor(private indicatorService: IndicatorService, private indicatorMediator: IndicatorMediator) { }

  async ngOnInit() {
    this.productSubtypeData = (await this.indicatorMediator.getIndicatorData(new ProductSubtypeIndicatorDataStrategy())) as ProductSubtypeIndicatorData;
    
    this.setChartData(this.productSubtypeData);
    
    this.isLoading = false;
  }

  public async onFilterData(company: Company) {
    this.isLoading = true;
    if (company) this.productSubtypeData = await this.indicatorService.getProductSubtypeData([company.getFiscalNumber()]);
    else this.productSubtypeData = await this.indicatorService.getProductSubtypeData();
    this.setChartData(this.productSubtypeData);
    
    // this.calculateYScaleInterval();
    this.isLoading = false;
  }

  public getProductSubTypeTotal(): string {
    return this.productSubtypeData && this.productSubtypeData.getProductSubTypeTotal();
  }

  private calculateYScaleInterval(): void {
    const maxValue = Math.max(this.productSubtypeData.getGenericQuantity(), this.productSubtypeData.getSimilarQuantity());
    const maxValueLength = maxValue.toString().length;
    const decimalMaxValue = maxValue / Math.pow(10, maxValueLength - 1);
    const ceilValue = Math.ceil(decimalMaxValue) * Math.pow(10, maxValueLength - 1);
    const interval = ceilValue / 5;
    this.barChartOptions.scales.yAxes[0].ticks.stepSize = interval;
  }

  public async setChartData(productSubtypeData: ProductSubtypeIndicatorData): Promise<void> {    
    const lineChartDataSets = [
      {
        data: [productSubtypeData.getGenericQuantity()],
        label: `Genérico: ${productSubtypeData.getGenericPercentage()}%`,
      },
      {
        data: [productSubtypeData.getSimilarQuantity()],
        label: `Marca: ${productSubtypeData.getSimilarPercentage()}%`,
      }
    ];
    this.lineChartData = {
      labels: this.lineChartLabels,
      datasets: lineChartDataSets,
    };
  }

}
